import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone'
import Commons from '../util/commons';
import useStore from "./useStore";

const usePrintSaleBuilder = () => {
    const { t, i18n } = useTranslation();
    const company = useStore(state => state.selectedCompany);
    moment.tz.setDefault('Europe/Athens');


    function getTaxByType(saleInstanceMoreTaxes, taxType) {
        if (saleInstanceMoreTaxes) {
            var item = saleInstanceMoreTaxes.filter(obj => {
                if (obj.deduction && obj.deduction.type) {
                    obj.myDataMoreTax = obj.deduction;
                }
                if (obj.amount) {
                    obj.myDataMoreTax.amount = obj.amount;
                }
                return obj.myDataMoreTax.type === taxType
            })

            // var myDataMoreTaxStr="";
            // item.forEach(t=>{
            //     myDataMoreTaxStr+=t.myDataMoreTax+" ,"
            // })
            // myDataMoreTaxStr =myDataMoreTaxStr.replace(/,\s*$/, "");


            return item && item.length ? item[0].myDataMoreTax : null
        }
    }


    const buildPrintSale = (sale, config = {}) => {
        const getTax = type => {
            let tax = getTaxByType(sale.saleInstanceMoreTaxes, type);
            if (type === 'OTHER_TAXES' && sale.otherTaxCategory) tax = sale.otherTaxCategory;
            return tax;
        };

        const taxes = {
            WITHHOLD_TAXES: getTax("WITHHOLD_TAXES"),
            OTHER_TAXES: getTax("OTHER_TAXES"),
            STUMP_DUTY: getTax("STUMP_DUTY"),
            FEES: getTax("FEES"),
            DEDUCTION: getTax("DEDUCTION"),
        };

        const vatExc = (sale.entries || sale.saleEntries || [])
            .map(e => e.vatCategoryException?.value ?? e.vatCategoryException)
            .filter(v => v != null);
        const vatExceptions = [...new Set(vatExc)];

        const nodes = sale.entries || sale.saleEntries || [];
        const printentries = nodes.map((node, i) => ({
            id: config.idFromNode?.(node, i) ?? i + 1,
            CODE: config.codeFromNode?.(node),
            NAME_LIST: config.nameFromNode(node),
            QUANTITY_LIST: node.quantity,
            MU_LIST: config.muFromNode(node, t),
            UP_LIST: Commons.formatNumber(node.unitPrice),
            DISCOUNT: Commons.formatNumber(node.discount),
            WHTAXES: config.whTaxFromNode(node),
            VAT_LIST: config.vatFromNode(node),
            PRICE_NOVAT_LIST: Commons.formatNumber(node.priceWithoutVat),
            PRICE_LIST: Commons.formatNumber(node.priceWithVat),
        }));

        const TOTALCOUNTITEMS = nodes.reduce((sum, n) => sum + (parseFloat(n.quantity) || 0), 0);

        const formatAddress = prefix => {
            let s = sale[`${prefix}AddressStreet`] ?? '';
            ['Number', 'City', 'PostalCode'].forEach(k => {
                const v = sale[`${prefix}Address${k}`];
                if (v) s += (k === 'City' ? ', ' : ' ') + v;
            });
            return s;
        };
        const LOADING_ADDRESS = formatAddress('loading');
        const DELIVERY_ADDRESS = formatAddress('delivery');
        const currency = sale.currency;
        const fmt = Commons.formatNumber;
        const fmtEuro = Commons.formatNumberEuro;

        var paymentTypes = "";
        if (sale.paymentMethods && sale.paymentMethods.length > 0) {
            sale.paymentMethods.forEach(m => {
                paymentTypes += t(m.paymentType) + ","
            });
            paymentTypes = paymentTypes.slice(0, -1);
        }

        var correlativeSales = "";
         if (sale.correlativeSaleInstances && sale.correlativeSaleInstances.length > 0) {
            sale.correlativeSaleInstances.forEach(m => {
                correlativeSales += t(m.mark) + ","
            });
            correlativeSales = correlativeSales.slice(0, -1);
        }

        
        return {
            TEMPLATE_LANG: (sale.templateLang || i18n.language).toLowerCase(),
            LOGO: sale.branch?.model?.logo ?? config.logo,
            ISSUER_DOY: company.taxOffice?.name ?? '',
            ISSUER_GEMH: company.gemh ?? '',
            ISSUER_NAME: config.issuerName ?? company.name,
            ISSUER_VAT: company.taxpayerId,
            ISSUER_ADDRESS: sale.branch?.model?.address ?? config.issuerAddress,
            ISSUER_PHONE: sale.branch?.model?.phone ?? config.issuerPhone,
            ISSUER_EMAIL: sale.branch?.model?.email ?? config.issuerEmail,
            ISSUER_SUBJECTFIELD: sale.branch?.model?.subjectField ?? config.subjectField,
            INVOICEMARK: sale.INVOICEMARK ?? sale.mark ?? config.mark,
            CANCELATIONMARK: sale.cancellationMark ?? config.cancelmark,
            TRANSMISSION_FAILURE:sale.transmissionFailure,
            INVOICEUID: sale.INVOICEUID ?? sale.invoiceUid,
            VEHICLE_NUMBER: sale.vehicleNumber,
            CP_NAME: sale.customer?.label ?? sale.customerName ?? config.customerName,
            CP_CODE: sale.customer?.model?.code ?? sale.customerCode ?? config.customerCode,
            INVOICE_TYPE: sale.invoiceType?.label ?? sale.invoiceTypeName,
            INVOICE_NUMBER: (sale.series?.label || sale.series) + ' ' + sale.invoiceNumber,
            MYDATA_INVOICE_TYPE: sale.invoiceType?.myDataInvoiceType ?? sale.myDataInvoiceType,
            CP_VAT: sale.taxpayerId ?? sale.customerTaxPayerId,
            INVOICE_DATE: moment(sale.invoiceDate, ['DD/MM/YYYY HH:mm:ssZ', 'DD/MM/YYYY', moment.ISO_8601]).format('DD/MM/YYYY'),
            INVOICE_TIME: moment(sale.invoiceDate, ['DD/MM/YYYY HH:mm:ssZ', 'DD/MM/YYYY', moment.ISO_8601]).format('HH:mm'),
            INVOICE_ENTRIES: printentries,
            TOTALNODISCOUNT: fmt(parseFloat(sale.totals?.totalWithoutDiscount ?? sale.totalWithoutDiscount)),
            TOTALWITHOUTVAT: fmt(parseFloat(sale.totals?.totalWithoutVat ?? sale.totalWithoutVat)),
            TOTALVAT: fmt(parseFloat((sale.totals?.totalWithVat - sale.totals?.totalWithoutVat) ?? 0).toFixed(2)),
            TOTALWITHVAT: fmt(sale.totals?.totalWithVat ?? sale.totalWithVat),
            TOTALPAYMENT: fmtEuro(sale.totals?.totalPayment ?? sale.totalPayment),
            TOTALDISCOUNT: fmt(sale.totals?.totalDiscount ?? sale.totalDiscount),
            TOTALTAXES: fmt(parseFloat((sale.totals?.totalPayment - sale.totals?.totalWithVat) ?? 0).toFixed(2)),
            CP_ADDRESS: (sale.fulladdress ?? sale.customerAddress) + " " + (sale.addressNumber ?? sale.customerAddressNumber),
            CP_CITY: (sale.city ?? sale.customerCity) + " " + (sale.postalCode ?? sale.customerPostalCode),
            TOTALCOUNTITEMS,
            CP_PAYTYPE: paymentTypes,
            CP_TAXOFFICE: sale.taxOffice?.label ?? sale.taxOfficeName,
            CP_SUBJECT_FIELD: sale.subjectField,
            NOTES: sale.notes,
            SEND_PLACE: sale.sendPlace ?? t("ourPlace"),
            TOTALOTHERTAXES: fmt(parseFloat(sale.totals?.totalOtherTaxes ?? sale.totalOtherTaxes)),
            TOTALWHTAXES: fmt(parseFloat(
                (sale.totals?.totalWithHoldTaxes - (sale.totals?.totalDeductionsTaxes ?? 0)) ?? 0
            )),
            TOTALFEESTAXES: fmt(parseFloat(sale.totals?.totalFeesTaxes ?? sale.totalFeesTaxes)),
            TOTALSTUMPOFDUTYTAXES: fmt(parseFloat(sale.totals?.totalStumpOfDutyTaxes ?? sale.totalStumpOfDutyTaxes)),
            TOTALDEDUCTIONTAXES: fmt(parseFloat(sale.totals?.totalDeductionsTaxes ?? sale.totalDeductionsTaxes ?? 0)),
            CURRENCY: currency?.value ?? currency,
            TOTALPAYMENT_ON_CURRENCY: currency ? fmt(parseFloat((sale.totals?.totalPayment ?? sale.totalPayment) * currency.rate).toFixed(2)) : "",
            SENDER_NAME: sale.senderName ?? config.senderName,
            SENDER_TAXPAYER_ID: sale.senderTaxPayerId ?? config.senderTaxpayerId,
            RECIPIENT_NAME: sale.recipientName ?? config.recipientName,
            RECIPIENT_TAXPAYER_ID: sale.recipientTaxpayerId ?? config.recipientTaxpayerId,
            VAT_EXCEPTION_CATEGORIES: vatExceptions,
            CORRELATIVE_INVOICE: correlativeSales,
            IBAN: sale.iban,
            MOREINFO: sale.moreInfo,
            QRURL: sale.qrUrl,
            COUNTRY: sale.country?.value ?? sale.customerCountry?.alpha2,
            WITHHOLD_TAXES: taxes.WITHHOLD_TAXES?.value ?? (taxes.WITHHOLD_TAXES ? `TAX_${taxes.WITHHOLD_TAXES.uid}` : null),
            OTHER_TAXES: taxes.OTHER_TAXES?.value ?? (taxes.OTHER_TAXES ? `TAX_${taxes.OTHER_TAXES.uid}` : null),
            STUMP_DUTY: taxes.STUMP_DUTY?.value ?? (taxes.STUMP_DUTY ? `TAX_${taxes.STUMP_DUTY.uid}` : null),
            FEES: taxes.FEES?.value ?? (taxes.FEES ? `TAX_${taxes.FEES.uid}` : null),
            DEDUCTION: taxes.DEDUCTION?.label ?? taxes.DEDUCTION?.name,
            MOVE_PURPOSE: sale.movePurpose ? t(sale.movePurpose.value ?? sale.movePurpose) : null,
            DISPATCH_DATE: sale.dispatchDate
                ? (typeof sale.dispatchDate === 'string'
                    ? sale.dispatchDate.split("+")[0].substring(0, 16)
                    : moment(sale.dispatchDate).format('DD/MM/YYYY HH:mm'))
                : null,
            saleInstanceMoreTaxes: sale.saleInstanceMoreTaxes,
            LOADING_ADDRESS,
            DELIVERY_ADDRESS,
        };
    };

    return { buildPrintSale };
};

export default usePrintSaleBuilder;
